import axios from "axios";
import configuration from "../configuration/configuration";

/**
 * Comptes du personnel (routes /api/employes, réservées aux administrateurs).
 * Les erreurs sont renvoyées telles quelles : le message du serveur est dans error.response.data.message.
 */
export default class EmployeAPI {

    async request(method, url, data) {
        const response = await axios({
            method: method,
            url: `${configuration.API}/api/${url}`,
            headers: {'content-type': 'application/json'},
            data: data
        });

        return response.data;
    }

    getAll() {
        return this.request('get', 'employes');
    }

    save(employe) {
        return employe.id
            ? this.request('put', `employes/${employe.id}`, employe)
            : this.request('post', 'employes', employe);
    }
}
